export default __webpack_public_path__ + "static/media/icono-ayuda.956fc35f.jpg";